/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import ApiUtils from 'api/ApiUtils';
import React, {useEffect, useState} from 'react';
import {Col, Form, Row} from 'react-bootstrap';
import {
  type EventFormProps,
  type CategoryDetailsTypes,
  type CategoryStatusList,
} from 'utils/TypeConfig';
import {useFormik} from 'formik';

import TooltipWithInfoIcon from 'Common/InfoTool';
import {tooltipMessage} from 'utils/Tooltips';
import {renderCategoryOptions} from 'helpers/CategoryOption';
import {variables} from 'utils/constant';
import Select, {type MultiValue} from 'react-select';
import {useSelector} from 'react-redux';
import customStyles from 'Common/customStyles';

interface UploadedFile {
  image: File;
  preview: string;
  type: 'image' | 'video';
}

const EventForm: React.FC<EventFormProps> = ({
  handleClose,
  setIsEditCategory,
  setIsAddCategory,
  editEvent,
}) => {
  const [status] = useState([
    {id: variables.EVENT_ACTIVE_STATUS_ID, name: variables.EVENT_ACTIVE_STATUS},
    {
      id: variables.EVENT_INACTIVE_STATUS_ID,
      name: variables.EVENT_INACTIVE_STATUS,
    },
  ]);

  const guestListStatus = [
    {id: variables.EVENT_ACTIVE_STATUS_ID, name: variables.EVENT_ACTIVE_STATUS},
    {
      id: variables.EVENT_INACTIVE_STATUS_ID,
      name: variables.EVENT_INACTIVE_STATUS,
    },
  ];
  const {Layout}: any = useSelector(state => state);
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    if (Layout.layoutModeType === 'dark') {
      setIsDark(true);
    } else if (Layout.layoutModeType === 'light') {
      setIsDark(false);
    } else {
      setIsDark(false);
    }
  }, [Layout.layoutModeType]);

  console.log('editEventeditEvent', editEvent);
  const [selectedOptions, setSelectedOptions] = useState<any>([]);

  console.log('🚀 ~ selectedOptions:', selectedOptions);

  const [options, setOption] = useState<any>([]);
  const [commissionStructure, setCommissionStructure] = useState<any>(null);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [uploadedFiles, setUploadedFiles] = useState<UploadedFile[]>([]);

  const [files, setFiles] = useState<any[]>([]);
  // const handleFilesAdded = (files: UploadedFile[]): void => {
  //   // console.log('🚀 ~ handleFilesAdded ~ files:', [...files]);
  //   setUploadedFiles(files);

  //   // validation.setFieldValue('files', [...files]);
  //   files.map((file: any) => {
  //     // eslint-disable-next-line no-void
  //     return void replaceImageWithCropped(file);
  //   });
  //   // Check if the files array is empty or contains only "delete" type items
  //   const hasDeleteType = files.every((file: any) => file.type === 'delete');

  //   // If all files are of type "delete" or the files array is empty, set the Formik field to empty
  //   if (files.length === 0 || hasDeleteType) {
  //     validation.setFieldValue('files', []);
  //   } else {
  //     // Otherwise, set the Formik field to the new files
  //     setUploadedFiles(files);
  //     validation.setFieldValue('files', [...files]);
  //   }
  // };

  // const replaceImageWithCropped = async (data: {
  //   fileName: string;
  //   croppedPreview: RequestInfo | URL;
  //   image: File;
  //   // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  // }) => {
  //   if (data.croppedPreview) {
  //     try {
  //       // Fetch the croppedPreview blob
  //       const response = await fetch(data.croppedPreview);
  //       const blob = await response.blob();

  //       // Create a new File object from the blob
  //       const croppedImageFile = new File([blob], data?.fileName, {
  //         type: blob.type,
  //       });

  //       // Replace the image with the cropped file
  //       data.image = croppedImageFile;
  //     } catch (error) {
  //       console.error('Error replacing image with cropped preview:', error);
  //     }
  //   } else {
  //     console.warn('No croppedPreview available to replace the image.');
  //   }
  // };

  useEffect(() => {
    // Define the async function for fetching data
    const fetchDressCodeList = async (): Promise<void> => {
      try {
        const response: any = await ApiUtils.getDressCodeList(); // Ensure parentheses
        const mapData = response?.data?.map((option: any) => {
          return {
            value: option.id,
            label: option.name,
          };
        });

        setOption(mapData || []); // Update state with fetched data
      } catch (error) {
        console.error('Error fetching dress code list:', error);
      }
    };
    void fetchDressCodeList();
    setFiles(editEvent?.event_image);
  }, []);

  const handleSelectDressCodeChange = (
    selectedOptions: MultiValue<{value: string; label: string}>,
  ): void => {
    setSelectedOptions([...selectedOptions]); // Convert read-only array to mutable array
    validation.setFieldValue('dress_code_id', [...selectedOptions]);
  };

  const [categoryList, setCategoryList] = useState([]);

  // const [fileDisplay, setFileDisplay] = useState<string>();

  const mappedDressCode = editEvent?.event_dress_code?.map(
    (eventDress: any) => {
      return {
        value: eventDress?.dress_code_id,
        label: eventDress?.dress_code_name,
      };
    },
  );

  useEffect(() => {
    setSelectedOptions(mappedDressCode);
    setCommissionStructure(editEvent?.commission_structure ?? null);
  }, []);

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      event_name: editEvent?.event_name !== '' ? editEvent?.event_name : '',
      main_artist_name:
        editEvent?.main_artist_name !== '' ? editEvent?.main_artist_name : '',
      other_artist_name:
        editEvent?.other_artist_name !== '' ? editEvent?.other_artist_name : '',

      venue_id: editEvent?.venue_id !== '' ? editEvent?.venue_id : null,
      address: editEvent?.address !== '' ? editEvent?.address : '',
      description: editEvent?.description !== '' ? editEvent?.description : '',
      date_time: editEvent?.date_time !== '' ? editEvent?.date_time : '',
      end_date: editEvent?.end_date !== '' ? editEvent?.end_date : '',
      guest_close_date_time:
        editEvent?.guest_close_date_time !== ''
          ? editEvent?.guest_close_date_time
          : '',
      selectedOptions:
        editEvent?.selectedOptions?.length !== 0
          ? editEvent?.selectedOptions
          : [],
      dress_code_id:
        editEvent?.event_dress_code?.length !== 0 ? mappedDressCode : [],

      status: editEvent?.status !== '' ? editEvent?.status : '',
      guest_status:
        editEvent?.guest_status !== '' ? editEvent?.guest_status : '',
      age_policy: editEvent?.age_policy !== '' ? editEvent?.age_policy : '',
      files: editEvent?.event_image?.length > 0 ? editEvent?.event_image : [],
      max_capacity:
        editEvent?.guest_max_capacity !== ''
          ? editEvent?.guest_max_capacity
          : '',
      priority_entry_rules:
        editEvent?.priority_entry_rules !== ''
          ? editEvent?.priority_entry_rules
          : '',
      booking_status:
        editEvent?.booking_status !== '' ? editEvent?.booking_status : '',
      weekday_discount:
        editEvent?.weekday_discount !== '' ? editEvent?.weekday_discount : '',
      weekend_discount:
        editEvent?.weekend_discount !== '' ? editEvent?.weekend_discount : '',
      table_max_capacity:
        editEvent?.table_max_capacity !== ''
          ? editEvent?.table_max_capacity
          : '',
    },
    onSubmit: async (values: any): Promise<void> => {},
  });

  useEffect(() => {
    const fetchCategoryList = async (): Promise<void> => {
      try {
        const response: any = await ApiUtils.getVenueList('?type=AddEvent');
        console.log('🚀 ~ fetchCategoryList ~ response:', response);
        setCategoryList(response);
      } catch (err) {
        console.error(err);
      }
    };

    void fetchCategoryList();
  }, []);

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const combinedStyles = (isDark: boolean, validation: any) => ({
    ...(isDark ? customStyles : {}), // Add dark mode styles if isDark is true
    control: (base: any, state: any) => ({
      ...base,
      backgroundColor: isDark ?? '#0f1f36', // Input background
      border: isDark ?? '2px solid #132846', // Custom border color and width
      borderColor:
        Boolean(validation.touched.dress_code_id) &&
        !(validation.errors.dress_code_id == null)
          ? 'red' // Red border for invalid
          : state.isFocused
            ? 'blue' // Blue border for focus
            : base.borderColor, // Default behavior
      '&:hover': {
        borderColor:
          Boolean(validation.touched.dress_code_id) &&
          !(validation.errors.dress_code_id == null)
            ? 'red'
            : state.isFocused
              ? 'blue'
              : base.borderColor,
      },
    }),
  });

  return (
    <div>
      <Form
        className="tablelist-form"
        onSubmit={e => {
          e.preventDefault();
          validation.handleSubmit();
        }}>
        <Row>
          <div
            id="alert-error-msg"
            className="d-none alert alert-danger py-2"></div>
          <input type="hidden" id="id-field" />

          <Col lg={12} className="mb-3">
            <Row>
              <div>
                <h5>Add event images/videos:</h5>
                {/* <FileUploader
                  onFilesAdded={handleFilesAdded}
                  accept={{
                    'image/*': ['.png', '.jpeg', '.jpg', '.gif'],
                    'video/*': ['.mp4', '.mov', '.avi'],
                  }}
                  multiple={true}
                  images={editEvent?.event_image}
                /> */}
                {files?.length > 0 && (
                  <div
                    style={{
                      marginTop: '20px',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '10px',
                    }}>
                    {files
                      .filter(file => file.type !== 'delete') // Exclude files with type 'delete'
                      .sort((a, b) => {
                        // Sort by sort_order, if available
                        if (a.sort_order && b.sort_order) {
                          return a.sort_order - b.sort_order; // Ascending order
                        }
                        return 0; // Keep the same order if sort_order is missing
                      })
                      .map((file, index) => (
                        <div
                          key={file?.file?.name}
                          style={{
                            border: '1px solid #ccc',
                            padding: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            boxSizing: 'border-box',
                            cursor: 'move',
                            // Apply different styles when the item is being dragged
                            backgroundColor: 'transparent',
                            opacity: '1',
                          }}>
                          {file.id ? (
                            <>
                              {(() => {
                                const fileName = file?.name || '';
                                const isImage =
                                  /\.(jpg|jpeg|png|gif|bmp|svg|webp)$/i.test(
                                    fileName,
                                  );
                                const isVideo =
                                  /\.(mp4|webm|ogg|mov|avi|flv|mkv)$/i.test(
                                    fileName,
                                  );
                                if (isImage) {
                                  return (
                                    <img
                                      src={fileName}
                                      alt={file?.image_name || 'Image'}
                                      style={{
                                        width: '50px',
                                        height: '50px',
                                        objectFit: 'cover',
                                        borderRadius: '5px',
                                      }}
                                    />
                                  );
                                } else if (isVideo) {
                                  return (
                                    <video
                                      src={fileName}
                                      controls
                                      style={{
                                        width: '50px',
                                        height: '50px',
                                        objectFit: 'cover',
                                        borderRadius: '5px',
                                      }}
                                    />
                                  );
                                } else {
                                  return <span>Unsupported file format</span>;
                                }
                              })()}

                              <p style={{flexGrow: 1, margin: 0}}>
                                {file?.image_name}
                              </p>
                            </>
                          ) : (
                            <>
                              {file.type === 'image' ? (
                                <>
                                  <img
                                    src={file.croppedPreview || file.preview}
                                    // alt={file.file.name}
                                    style={{
                                      width: '50px',
                                      height: '50px',
                                      objectFit: 'cover',
                                    }}
                                  />
                                  <p style={{flexGrow: 1, margin: 0}}>
                                    {file?.image.name}
                                  </p>
                                </>
                              ) : (
                                <>
                                  <video
                                    src={file.croppedPreview || file.preview}
                                    controls
                                    style={{
                                      width: '50px',
                                      height: '50px',
                                      objectFit: 'cover',
                                    }}
                                  />
                                  <p style={{flexGrow: 1, margin: 0}}>
                                    {file?.image.name}
                                  </p>
                                </>
                              )}
                            </>
                          )}
                        </div>
                        // ) : null,
                      ))}
                  </div>
                )}
              </div>
            </Row>
          </Col>
          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="productType-field">Venue</Form.Label>
                <span className="text-danger required-mark">*</span>

                <TooltipWithInfoIcon text={tooltipMessage.SelectVenue} />
              </div>
              <Form.Select
                disabled
                className="form-select"
                name="venue_id"
                id="productType-field"
                onChange={e => {
                  // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
                  const selectedVenue: any = categoryList.find(
                    // eslint-disable-next-line array-callback-return
                    (venue: CategoryDetailsTypes) =>
                      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                      String(venue.id) == e.target.value,
                  );

                  validation.setFieldValue('venue_id', e.target.value);
                  validation.setFieldValue(
                    'address',
                    selectedVenue?.address || '',
                  );
                }}
                value={
                  validation.values.venue_id ||
                  (editEvent?.venue_id !== '' ? editEvent?.venue_id : '')
                }>
                <option value="">Select Venue</option>
                {categoryList?.map((data: CategoryDetailsTypes, i) => {
                  // Ensure the category name does not match the editEvent's name
                  if (editEvent?.event_name !== data.name) {
                    const categoryName = renderCategoryOptions(
                      data,
                      categoryList,
                      [],
                      editEvent?.event_name,
                    );

                    return (
                      <option value={data.id} key={i}>
                        {categoryName}
                      </option>
                    );
                  }
                  return null; // Avoid rendering anything if the condition is not met
                })}
              </Form.Select>
            </div>
          </Col>
          <Col lg={4}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-name">
                  Event Name
                  <span className="text-danger required-mark">*</span>
                </Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.EventName} />
              </div>
              <Form.Control
                readOnly
                type="text"
                id="event-name"
                placeholder="Enter Event Name"
                name="event_name"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.event_name || editEvent?.event_name
                    ? editEvent?.event_name
                    : ''
                }
              />
            </div>
          </Col>
          <Col lg={4}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-name">
                  Main Artist Name
                </Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.MainArtistName} />
              </div>
              <Form.Control
                readOnly
                type="text"
                id="event-name"
                placeholder="Enter Main Artist Name"
                name="main_artist_name"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.main_artist_name ||
                  editEvent?.main_artist_name
                    ? editEvent?.main_artist_name
                    : ''
                }
              />
            </div>
          </Col>
          <Col lg={4}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-name">
                  Other Artist Name
                </Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.OtherArtistName} />
              </div>
              <Form.Control
                readOnly
                type="text"
                id="event-name"
                placeholder="Enter Other Artist Name"
                name="other_artist_name"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.other_artist_name ||
                  editEvent?.other_artist_name
                    ? editEvent?.other_artist_name
                    : ''
                }
              />
            </div>
          </Col>

          <Col lg={4}>
            <div className="mb-3">
              <div className="d-flex">
                Event Date & Time{' '}
                <span className="text-danger required-mark">*</span>
                <TooltipWithInfoIcon text={tooltipMessage.EventStartDate} />
              </div>
              <Form.Control
                readOnly
                type="datetime-local"
                id="date-time"
                name="date_time"
                min={new Date().toISOString().slice(0, 16)}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.date_time}
              />
            </div>
          </Col>

          <Col lg={4}>
            <div className="mb-3">
              <div className="d-flex">
                Event End Date & Time{' '}
                <span className="text-danger required-mark">*</span>
                <TooltipWithInfoIcon text={tooltipMessage.EventEndDate} />
              </div>
              <Form.Control
                readOnly
                type="datetime-local"
                id="end-date-time"
                name="end_date"
                min={new Date().toISOString().slice(0, 16)}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.end_date}
              />
            </div>
          </Col>

          <Col lg={12}>
            <div aria-labelledby="category-name-label" className="mb-3">
              <div className="d-flex">
                <Form.Label id="category-name-label" htmlFor="category-name">
                  Dress Code
                </Form.Label>
                <TooltipWithInfoIcon text={tooltipMessage.DressCode} />
              </div>
              <Select
                isDisabled={true}
                isMulti
                className="custom-select"
                id="venue-name"
                name="dress_code_id"
                value={selectedOptions}
                onChange={handleSelectDressCodeChange}
                styles={combinedStyles(isDark, validation)}
                options={options}></Select>
            </div>
          </Col>

          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="status-Field">
                  Guest List Status
                </Form.Label>
                <span className="text-danger required-mark">*</span>

                <TooltipWithInfoIcon text={tooltipMessage.EventStatus} />
              </div>

              <Form.Select
                disabled
                className="form-select"
                name="guest_status"
                id="status-Field"
                onChange={e =>
                  validation.setFieldValue('guest_status', e.target.value)
                }
                value={
                  validation.values.guest_status ||
                  (editEvent?.guest_status !== ''
                    ? editEvent?.guest_status
                    : '')
                }>
                <option value="">Guest Status</option>
                {guestListStatus?.map((data: CategoryStatusList, i) => (
                  <option key={i} value={data.id}>
                    {data.name}
                  </option>
                ))}
              </Form.Select>
            </div>
          </Col>

          {/* Conditionally render Guest Close Time */}
          {validation.values.guest_status &&
            parseInt(validation.values.guest_status) === 1 && (
              <>
                <Col lg={12}>
                  <div className="mb-3">
                    <div className="d-flex">
                      Guest list close time{' '}
                      <span className="text-danger required-mark">*</span>
                      <TooltipWithInfoIcon
                        text={tooltipMessage.GuestListCloseTime}
                      />
                    </div>
                    <Form.Control
                      readOnly
                      type="datetime-local"
                      id="guest-close-date-time"
                      name="guest_close_date_time"
                      min={new Date().toISOString().slice(0, 16)}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.guest_close_date_time}
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <div className="d-flex">
                      <Form.Label htmlFor="category-name">
                        Guest max capacity(people)
                        <span className="text-danger required-mark">*</span>
                      </Form.Label>

                      <TooltipWithInfoIcon text={tooltipMessage.MaxCapacity} />
                    </div>
                    <Form.Control
                      readOnly
                      type="number"
                      id="max_capacity"
                      placeholder="Enter Guest  Max Capacity"
                      name="max_capacity"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      defaultValue={
                        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                        validation?.values?.max_capacity ||
                        editEvent?.guest_max_capacity
                          ? editEvent?.guest_max_capacity
                          : ''
                      }
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <div className="d-flex">
                      <Form.Label htmlFor="category-name">
                        Priority Entry Rules
                        {/* <span className="text-danger required-mark">*</span> */}
                      </Form.Label>

                      <TooltipWithInfoIcon
                        text={tooltipMessage.priorityEntryRules}
                      />
                    </div>
                    <Form.Control
                      readOnly
                      type="text"
                      id="priority_entry_rules"
                      placeholder="Enter Priority Entry Rules"
                      name="priority_entry_rules"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      defaultValue={
                        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                        validation?.values?.priority_entry_rules ||
                        editEvent?.priority_entry_rules
                          ? editEvent?.priority_entry_rules
                          : ''
                      }
                    />
                  </div>
                </Col>
              </>
            )}

          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="booking_status">Booking Status</Form.Label>
                <span className="text-danger required-mark">*</span>

                <TooltipWithInfoIcon text={tooltipMessage.EventStatus} />
              </div>

              <Form.Select
                disabled
                className="form-select"
                name="booking_status"
                id="booking_status"
                onChange={e =>
                  validation.setFieldValue('booking_status', e.target.value)
                }
                value={
                  validation.values.booking_status ||
                  (editEvent?.booking_status !== ''
                    ? editEvent?.booking_status
                    : '')
                }>
                <option value="">Booking Status</option>
                {status?.map((data: CategoryStatusList, i) => (
                  <option key={i} value={data.id}>
                    {data.name}
                  </option>
                ))}
              </Form.Select>
            </div>
          </Col>

          {/* Conditionally render Guest Close Time */}
          {validation.values.booking_status &&
            parseInt(validation.values.booking_status) === 1 && (
              <>
                <Col lg={6}>
                  <div className="mb-3">
                    <div className="d-flex">
                      <Form.Label htmlFor="category-name">
                        Weekday Discount %
                        <span className="text-danger required-mark">*</span>
                      </Form.Label>

                      <TooltipWithInfoIcon
                        text={tooltipMessage.weekdayDiscount}
                      />
                    </div>
                    <Form.Control
                      readOnly
                      type="number"
                      id="weekday_discount"
                      placeholder="Enter Weekday Discount"
                      name="weekday_discount"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      defaultValue={
                        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                        validation?.values?.weekday_discount ||
                        editEvent?.weekday_discount
                          ? editEvent?.weekday_discount
                          : ''
                      }
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <div className="d-flex">
                      <Form.Label htmlFor="category-name">
                        Weekend Discount %
                        <span className="text-danger required-mark">*</span>
                      </Form.Label>

                      <TooltipWithInfoIcon
                        text={tooltipMessage.weekendDiscount}
                      />
                    </div>
                    <Form.Control
                      readOnly
                      type="number"
                      id="weekend_discount"
                      placeholder="Enter Weekend Discount"
                      name="weekend_discount"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      defaultValue={
                        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                        validation?.values?.weekend_discount ||
                        editEvent?.weekend_discount
                          ? editEvent?.weekend_discount
                          : ''
                      }
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <div className="d-flex">
                      <Form.Label htmlFor="category-name">
                        Table max capacity(people)
                        <span className="text-danger required-mark">*</span>
                      </Form.Label>

                      <TooltipWithInfoIcon
                        text={tooltipMessage.TableMaxCapacity}
                      />
                    </div>
                    <Form.Control
                      readOnly
                      type="number"
                      id="table_max_capacity"
                      placeholder="Enter Table Max Capacity"
                      name="table_max_capacity"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      defaultValue={
                        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                        validation?.values?.table_max_capacity ||
                        editEvent?.table_max_capacity
                          ? editEvent?.table_max_capacity
                          : ''
                      }
                    />
                  </div>
                </Col>
                <Col lg={6}> </Col>
              </>
            )}

          <Col lg={6}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="status-Field">Status</Form.Label>
                <span className="text-danger required-mark">*</span>

                <TooltipWithInfoIcon text={tooltipMessage.EventStatus} />
              </div>

              <Form.Select
                disabled
                className="form-select"
                name="status"
                id="status-Field"
                onChange={e =>
                  validation.setFieldValue('status', e.target.value)
                }
                value={
                  validation.values.status ||
                  (editEvent?.status !== '' ? editEvent?.status : '')
                }
                isInvalid={
                  !!(validation.touched.status && validation.errors.status)
                }>
                <option value="">Status</option>
                {status?.map((data: CategoryStatusList, i) => (
                  <option key={i} value={data.id}>
                    {data.name}
                  </option>
                ))}
              </Form.Select>
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-name">Age Policy</Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.AgePolicy} />
              </div>
              <Form.Control
                readOnly
                type="text"
                id="event-name"
                placeholder="Enter age policy"
                name="age_policy"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.age_policy || editEvent?.age_policy
                    ? editEvent?.age_policy
                    : ''
                }
              />
            </div>
          </Col>

          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                Event Address{' '}
                <span className="text-danger required-mark">*</span>
                <TooltipWithInfoIcon text={tooltipMessage.EventAddress} />
              </div>
              <Form.Control
                readOnly
                as="textarea"
                id="address"
                name="address"
                rows={4}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.address}
                isInvalid={
                  Boolean(validation.touched.address) &&
                  !(validation.errors.address == null)
                }
              />
              {Boolean(validation.touched.address) && (
                <Form.Control.Feedback type="invalid">
                  {validation.errors.address as string}
                </Form.Control.Feedback>
              )}
            </div>
          </Col>

          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                Description
                {/* <span className="text-danger">*</span> */}
                <TooltipWithInfoIcon text={tooltipMessage.EventDescription} />
              </div>
              <Form.Control
                readOnly
                as="textarea"
                id="description"
                name="description"
                rows={4}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.description}
                isInvalid={
                  Boolean(validation.touched.description) &&
                  !(validation.errors.description == null)
                }
              />
              {Boolean(validation.touched.description) && (
                <Form.Control.Feedback type="invalid">
                  {validation.errors.description as string}
                </Form.Control.Feedback>
              )}
            </div>
          </Col>

          {/* <Col lg={6}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="commission_structure">
                  Commission Structure
                </Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.EventStatus} />
              </div>

              <Form.Control
                type="file"
                accept="application/pdf"
                id="commission_structure"
                name="commission_structure"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  const file = event.currentTarget.files?.[0] ?? null;
                  setCommissionStructure(null);
                  validation.setFieldValue('commission_structure', file);
                }}
                isInvalid={
                  !!(
                    Boolean(validation.touched.commission_structure) &&
                    Boolean(validation.errors.commission_structure)
                  )
                }
              />

              {Boolean(validation.touched.commission_structure) &&
              Boolean(validation.errors.commission_structure) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.commission_structure}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col> */}

          {commissionStructure !== null || commissionStructure !== undefined ? (
            <Col lg={6}>
              <div>
                {commissionStructure ? (
                  <div className="mt-4">
                    <a
                      href={commissionStructure}
                      target="_blank"
                      rel="noopener noreferrer">
                      View Commission Structure PDF
                    </a>
                    {/* <button
                      className="btn btn-sm btn-danger mx-2"
                      onClick={handleDeleteFile}>
                      <i className="ri-delete-bin-fill align-bottom  text-muted" />
                    </button> */}
                  </div>
                ) : null}
              </div>
            </Col>
          ) : null}
        </Row>
      </Form>
    </div>
  );
};

export default EventForm;
